<template>
    <div
        class="modal"
        :class="{'is-active': opened === 1 ? true : false}">
        <div class="modal-background animated faster" v-on:click.self="closeModal"></div>
        <div class="modal-card is-large animated faster">
            <header class="modal-card-head">
                <p class="modal-card-title">{{title}}</p>
                <button class="delete" @click="closeModal"></button>
            </header>
            <section class="modal-card-body">
                <slot></slot>
            </section>
            <footer class="modal-card-foot" />
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Modal',
        props: ['title'],

        data: () => ({
            opened: 0
        }),

        methods: {
            openModal(){
                let modalCardClassList = document.getElementsByClassName('modal-card')[0].classList,
                    modalBackgroundClassList = document.getElementsByClassName('modal-background')[0].classList;


                modalBackgroundClassList.add('fadeIn');
                modalCardClassList.add('fadeInDown');

                modalBackgroundClassList.remove('fadeOut');
                modalCardClassList.remove('fadeOutUp');

                this.opened = 1;
            },

            closeModal() {
                let modalCardClassList = document.getElementsByClassName('modal-card')[0].classList,
                    modalBackgroundClassList = document.getElementsByClassName('modal-background')[0].classList;

                modalBackgroundClassList.add('fadeOut');
                modalCardClassList.add('fadeOutUp');

                modalBackgroundClassList.remove('fadeIn');
                modalCardClassList.remove('fadeInDown');

                setTimeout(() => {
                    this.opened = 0;
                }, 500);
            },
        }
    }
</script>